export const vs2jen2LimitedReleasesListConstants = {
  VS2JEN2_LIMITED_RELEASES_LIST_LOADING:
    "VS2JEN2_LIMITED_RELEASES_LIST_LOADING",
  VS2JEN2_LIMITED_RELEASES_LIST_SUCCESS:
    "VS2JEN2_LIMITED_RELEASES_LIST_SUCCESS",
  VS2JEN2_LIMITED_RELEASES_LIST_FAILURE:
    "VS2JEN2_LIMITED_RELEASES_LIST_FAILURE",
};
